import i18n, { getTextByLang } from '@whelk/utils/src/i18n';

export const NETWORK_ERROR_MAP = ['Network Error', 'Failed to fetch'];
export const NETWORK_ERROR = getTextByLang('toast_network_error', i18n.language);

export const NETWORK_SUCCESS_CODE = 200;
export const UNAUTHORIZED_CODE = 401;

export const COMMON_SERVER_TIMEOUT = 2 * 60 * 1000;

export const FILE_MAX_UPLOAD_SERVER_TIMEOUT = 10 * 60 * 1000;
